import React from 'react';
import GeneralModal from '@gp/components/GeneralModal';
import { useMemoizedFn } from 'ahooks';
import VisualEditForm from '@gp/pages/Pipeline/ProjectDetails/GameDetail/components/VisualShowcase/components/VisualEditForm';
import type { IMaterialVO } from '@gp/types/global';
import type { IMilestoneFinancialVO, IMilestoneFinancialForecastVO } from '@gp/types/milestones';
import type { IGRAction } from '@gp/pages/Pipeline/ProjectDetails/Milestone/types';
import './index.scss';

export interface IUpdateGRFormModel {
  gate_review: string;
  gate_review_decision: string;
  dev_cost_actual: string;
  budget_next_milestone: string;
  approved_budget_to_next: string;
  dev_cost: string;
  key_milestones_financial: IMilestoneFinancialVO[];
  key_milestones_financial_forecast: IMilestoneFinancialForecastVO[];
  key_feedback: string;
  action_items: IGRAction[];
  next_milestone_scope: string;
  material: IMaterialVO[];
}

export interface IUpdateGRModalInstance {
  init: (payload: Partial<IUpdateGRFormModel>, currentMilestoneDate?: string) => void;
}

const VisualShowcaseModal = (props: any) => {
  const { visible = false, onCancel, visualcaseData, milestoneData, refreshFun, gameInformationData } = props;

  const handleCancel = useMemoizedFn(() => {
    onCancel?.(false);
  });

  return (
    <GeneralModal
      visible={visible}
      title="Visual Showcase"
      isFont14={true}
      className="dbg-visual-edit-modal"
      modalSize="auto"
      onClose={handleCancel}
      isFooter={false}
      content={
        <VisualEditForm
          {...{
            closeVisual: onCancel,
            visualcaseData,
            visualCaseDataRefresh: refreshFun,
            gameInformationData,
            milestoneData,
          }}
        />
      }
    />
  );
};

export default VisualShowcaseModal;
